import { forwardRef, type SVGProps } from 'react';
import { Ticket, type CarbonIconType } from '@carbon/icons-react';
import { Guitar, Tickets } from '@carbon/pictograms-react';

import styles from './iconesDosModulos.module.scss';

// OS ÍCONES OFICIAIS DO CONTROLE DE SHOWS (pedido do Lucas, 27/09/2026): o grupo e Vendas são o
// ingresso, e Produção é o violão. Para que o menu, os cartões do Início, o desbloqueio, o módulo
// travado e os vazios mostrem o MESMO desenho, cada um é um componente que aceita o `size` de um
// ícone (o menu dá 16, o desbloqueio passa 20) e, com a classe de quem o mede (o `Vazio`), sai no
// tamanho de pictograma.
//
// No tamanho de ícone, o ingresso é o `Ticket` nativo do Carbon (16px, nítido). O violão não tem
// ícone de 16px no Carbon: é o pictograma, com o traço engrossado para ficar no peso dos ícones.

type Props = SVGProps<SVGSVGElement> & { size?: number | string; title?: string };
type Pictograma = typeof Guitar;

const comoIcone = (P: Pictograma, nome: string, Pequeno?: CarbonIconType) => {
  const C = forwardRef<SVGSVGElement, Props>(({ size, className, ...resto }, ref) => {
    // Sem `size` e sem classe é o uso de ícone (16px, como um ícone do Carbon); com a classe de quem
    // o mede, é o pictograma, e a folha dele dá o tamanho.
    const tamanho = size ?? (className ? undefined : 16);
    const pequeno = tamanho != null && Number(tamanho) <= 32;
    if (pequeno && Pequeno) return <Pequeno ref={ref} size={tamanho} className={className} {...(resto as object)} />;
    const classe = [pequeno ? styles.pequeno : '', className].filter(Boolean).join(' ');
    return <P ref={ref} {...(tamanho != null ? { width: tamanho, height: tamanho } : {})} {...(resto as object)} className={classe} />;
  });
  C.displayName = nome;
  return C as unknown as CarbonIconType;
};

/** O grupo Controle de shows, no menu e na landing: o ingresso, o ícone nativo do Carbon. */
export const IconeDoControleDeShows = Ticket;
export const IconeDeVendas = comoIcone(Tickets, 'IconeDeVendas', Ticket);
export const IconeDaProducao = comoIcone(Guitar, 'IconeDaProducao');
